import React from "react";
import { withRouter } from 'react-router-dom'
import { Layout, Button, Dropdown, Space, AutoComplete, Flex, Input, Badge, Select, Tooltip, Modal, Image, Spin } from 'antd';
import {
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    DownOutlined,
    MailOutlined,
    UserOutlined, InfoOutlined, InfoCircleOutlined,
    PushpinOutlined,
    ShopOutlined,
    BellOutlined
} from '@ant-design/icons';
import firebase from "../../firebase";
import { db } from "../../App";
import "./P4Header.css";
const { Header } = Layout;

const Title = (props) => (
    <Flex align="center" justify="space-between">
        {props.title}
        <a href="https://www.google.com/search?q=antd" target="_blank" rel="noopener noreferrer">
            more
        </a>
    </Flex>
);

class P4Header1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: false,
            organization: null,
            company: null,
            seller: null,
            email: null,
            seller_company: null,
            sellerOrganizations: [],
            buyerOrganizations: [],
            sellerOrg: null,
            selectCountOrgs: [],
            showNotif: false,
            showNotification: false,
            notification: {}
        }
    }

    sumObjectsByKey = (...objs) => {
        return objs.reduce((a, b) => {
            for (let k in b) {
                if (b.hasOwnProperty(k))
                    a[k] = (a[k] || 0) + b[k];
            }
            return a;
        }, {});
    }

    getSDSCounts = () => {
        let normal = 0;
        let warning = 0;
        let alert = 0;
        let wait = 0;

        if (this.props.user && this.props.user.admin) {
            if (this.props.orgSeller) {
                if (this.props.org) {
                    const pairKey = `${this.props.orgSeller.id}_${this.props.org.id}`;
                    normal = (this.props.sdsNormalCountPairs && this.props.sdsNormalCountPairs[pairKey]) || 0;
                    warning = (this.props.sdsWarningCountPairs && this.props.sdsWarningCountPairs[pairKey]) || 0;
                    alert = (this.props.sdsAlertCountPairs && this.props.sdsAlertCountPairs[pairKey]) || 0;
                    wait = (this.props.sdsWaitingCountPairs && this.props.sdsWaitingCountPairs[pairKey]) || 0;
                } else {
                    normal = (this.props.sdsNormalCountWithOrg && this.props.sdsNormalCountWithOrg[this.props.orgSeller.id]) || 0;
                    warning = (this.props.sdsWarningCountWithOrg && this.props.sdsWarningCountWithOrg[this.props.orgSeller.id]) || 0;
                    alert = (this.props.sdsAlertCountWithOrg && this.props.sdsAlertCountWithOrg[this.props.orgSeller.id]) || 0;
                    wait = (this.props.sdsWaitingCountWithOrg && this.props.sdsWaitingCountWithOrg[this.props.orgSeller.id]) || 0;
                }
            }
        } else {
            if (this.props.org) {
                normal = (this.props.sdsNormalCountWithOrg && this.props.sdsNormalCountWithOrg[this.props.org.id]) || 0;
                warning = (this.props.sdsWarningCountWithOrg && this.props.sdsWarningCountWithOrg[this.props.org.id]) || 0;
                alert = (this.props.sdsAlertCountWithOrg && this.props.sdsAlertCountWithOrg[this.props.org.id]) || 0;
                wait = (this.props.sdsWaitingCountWithOrg && this.props.sdsWaitingCountWithOrg[this.props.org.id]) || 0;
            } else {
                normal = this.props.sdsNormalCount || 0;
                warning = this.props.sdsWarningCount || 0;
                alert = this.props.sdsAlertCount || 0;
                wait = this.props.sdsWaitingCount || 0;
            }
        }

        return { normal, warning, alert, wait };
    }


    getTopOrgs = async () => {
        let querySnapshot = await this.props.db
            .collection('org_select')
            .doc(this.props.user.id)
            .collection('org')
            .orderBy('pinned', 'desc')
            .orderBy('selectCount', 'desc')
            .get();

        let selectCountOrgs = querySnapshot.docs.map(org => {
            return { id: org.id, ...org.data() }
        });

        // console.log('selectCountOrgs', selectCountOrgs)

        this.setState({ selectCountOrgs })
    }

    componentDidMount() {
        console.log(this.props.userOrg)
        if (this.props.userOrg) {
            this.organizationCheck(this.props.userOrg?.id, true);
        } else if (this.props.user && this.props.user.organizations && this.props.user.organizations.length === 1) {
            this.organizationCheck(this.props.user.organizations[0].organization, false);
        }

        if (this.props.user && this.props.user.admin) {
            this.organizationCheck(null, true);
        }
        this.getTopOrgs();
    }

    componentDidUpdate(prevProps, prevState) {
        const { organization } = this.state;

        // 1. Auto-select seller org when organization info is loaded (Existing logic)
        if (!this.props.org && organization && organization.seller && organization.seller_name && organization.seller !== organization.id) {
            if (prevState.organization !== organization || prevProps.org !== this.props.org) {
                this.props.orgSelect(organization.seller, organization.seller_name);
            }
        }

        // 2. NEW: Auto-select user's only organization (Moved from render)
        if (this.props.user && this.props.user.organizations) {
            const belongsToUserOrg = this.props.userOrg && this.props.user.organizations.some(org => org.organization === this.props.userOrg.id);
            if (!this.props.userOrg || !belongsToUserOrg) {
                if (this.props.user.organizations.length === 1) {
                    const singleOrgId = this.props.user.organizations[0].organization;
                    // Only trigger if user info changed or userOrg was cleared/invalid
                    if (prevProps.user !== this.props.user || prevProps.userOrg !== this.props.userOrg) {
                        this.organizationCheck(singleOrgId, false);
                    }
                }
            }
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        // console.log('componentWillReceiveProps', nextProps.cancelOrder, nextProps.cancelOrderWithOrg)
        this.notificationLoad(nextProps.userOrg, nextProps.org);
        // console.log('componentWillReceiveProps',nextProps.userOrg, nextProps.org)
        this.getTopOrgs();
        if ((nextProps.orgSeller && nextProps.orgSeller.id) !== this.state.sellerOrg) {
            // console.log(nextProps.orgSeller.id)
            this.setState({
                sellerOrg: nextProps.orgSeller.id
            }, () => {
                this.selectSellerOrganization(nextProps.orgSeller, true);
            })
        }

        if (nextProps.userOrg && (!this.props.userOrg || this.props.userOrg.id !== nextProps.userOrg.id)) {
            this.organizationCheck(nextProps.userOrg.id, true);
        } else if (!nextProps.userOrg && this.props.userOrg) {
            this.setState({ organization: null });
        }
    }

    selectSellerOrganization = (seller, initial) => {
        //console.log('seller,initial',seller,initial);
        //this.setState({activeOrg1: {organization: seller.id, name: seller.company_name + ' ' + seller.name}});
        // this.props.orgSelect(e)
        this.setState({
            buyerOrganizations: seller.buyers || []
        })
        this.props.orgSelectSeller(seller.id, (seller.company_name || (seller.name2 || '')) + ' ' + (seller.name2 ? '' : seller.name), initial);
        // this.props.orgSelect(null, null);
        // console.log('this.props.org && this.props.org.display_name',this.props.org && this.props.org.display_name,this.state.searchOrg);
        // console.log('this.props',this.props);
    }

    // selectUserOrganization = ()

    selectUserOrg = (value, option) => {
        // console.log('selectUserOrg', value, option)
        this.organizationCheck(option.id, false);
    }

    organizationCheck = (orgId, init) => {
        if (orgId) {
            // console.log('organizationCheck', orgId)
            let organizationRef = this.props.db.collection('organizations').doc(orgId);
            let getDoc = organizationRef.get()
                .then(doc => {
                    if (!doc.exists) {
                        console.log('No such organization document!');

                        this.setState({
                            organization: null,
                        });

                        this.companyCheck(init);
                        // this.sellerCheck();
                    } else {
                        if (doc.data().active) {
                            let org = doc.data();
                            org.id = doc.id;
                            // console.log('org', org)

                            this.setState({
                                organization: org,
                            });

                            this.companyCheck(init);
                            // this.sellerCheck();
                        }
                    }
                })
                .catch(err => {
                    console.log('Error getting organization document', this.props.userOrg?.id, err)
                })
        } else if (this.props.user && this.props.user.admin) {
            this.adminUserList()
                .then((snapshot) => {
                    if (snapshot.length > 0) {
                        let organizations = [];
                        snapshot.forEach((doc) => {
                            let data = doc.data();
                            data.id = doc.id;
                            organizations.push(data)
                        });

                        // console.log('organization check', this.props.orgSeller, this.props.org)

                        let buyerOrganizations = [];
                        if (this.props.orgSeller) {
                            buyerOrganizations = this.props.orgSeller.buyers || [];
                        }

                        this.setState({
                            sellerOrganizations: organizations,
                            buyerOrganizations: buyerOrganizations
                        })
                    } else {
                        console.log('No such organization document!')
                    }
                })
        }

    }

    adminUserList = async () => {
        const seller = this.props.db.collection('organizations').where('reseller', '==', true).get();
        const maker = this.props.db.collection('organizations').where('maker', '==', true).get();

        const [
            sellerSnapshot,
            makerSnapshot
        ] = await Promise.all([seller, maker]);

        const sellerArray = sellerSnapshot.docs || [];
        const makerArray = makerSnapshot.docs || [];

        //Note that we don't need to de-duplicate in this case
        return sellerArray.concat(makerArray);
    }

    companyCheck = (init) => {
        // console.log('companyCheck')
        if (this.state.organization) {
            let companyRef = this.props.db.collection('company').doc(this.state.organization.company);
            let getDoc = companyRef.get()
                .then(doc => {
                    if (!doc.exists) {
                        console.log('No such company document!');
                        this.props.setupOrgAndCompany(null, init);
                    } else {
                        if (doc.data().active) {
                            let company = doc.data();
                            company.id = doc.id;
                            this.setState({
                                company: company,
                            });
                            let org = this.state.organization;
                            org.display_name = company.name + ' ' + org.name;
                            console.log('org', org.display_name, company.name, org.name)

                            this.props.setupOrgAndCompany(org, init);
                        }
                    }
                })
                .catch(err => {
                    console.log('Error getting company document', err)
                })
        } else {
            this.props.setupOrgAndCompany(null, init);
        }
    }

    sellerCheck = () => {
        // console.log('sellerCheck', this.state.organization)
        if (this.state.organization && this.state.organization.seller) {
            let sellerRef = this.props.db.collection('organizations').doc(this.state.organization.seller);
            let getDoc = sellerRef.get()
                .then(doc => {
                    if (!doc.exists) {
                        console.log('No such seller document!')
                    } else {
                        if (doc.data().active) {
                            let seller = doc.data();
                            seller.id = doc.id;
                            this.setState({
                                seller: seller,
                            });
                            // console.log('seller', seller)
                            this.seller_companyCheck();
                        }
                    }
                })
                .catch(err => {
                    console.log('Error getting seller document', err)
                })
        }
    }

    seller_companyCheck = () => {
        if (this.state.organization) {
            let companyRef = this.props.db.collection('company').doc(this.state.seller.company);
            let getDoc = companyRef.get()
                .then(doc => {
                    if (!doc.exists) {
                        console.log('No such seller_company document!')
                    } else {
                        if (doc.data().active) {
                            this.setState({
                                seller_company: doc.data(),
                            });
                            this.props.orgSelectData(this.state.seller.id, this.state.seller_company.name + ' ' + this.state.seller.name);
                        }
                    }
                })
                .catch(err => {
                    console.log('Error getting seller_company document', err)
                })
        }
    }

    handleMenuClick = (e) => {
        switch (e.key) {
            case '1':
                this.props.history.push('/emailsettings')
                break;
            case '11':
                this.props.history.push('/support')
                break;
            case '2':
                this.props.logout();
                break;
        }
    }

    selectOrg = async (value, option) => {
        // console.log('selectOrg')
        this.setState({
            activeOrg: {
                organization: option.id,
                name: option.name
            }
        });
        let pinOrgRef = this.props.db.collection('org_select').doc(this.props.user.id).collection('org').doc(option.id);
        let pinOrgSnapshot = await pinOrgRef.get();

        if (!pinOrgSnapshot.exists) {
            await pinOrgRef.set({ selectCount: firebase.firestore.FieldValue.increment(1), pinned: false }, { merge: true });
        } else {
            await pinOrgRef.set({ selectCount: firebase.firestore.FieldValue.increment(1) }, { merge: true });
        }

        this.props.orgSelect(option.id, option.name);
    }

    notificationLoad = async (userOrg, org) => {
        let isBuyer = false;
        let isSeller = false;



        if ((userOrg && userOrg.buyer && org && org.reseller)
            || (userOrg && userOrg.reseller && org && org.maker)
        ) {
            isBuyer = true;
        }
        if ((userOrg && userOrg.reseller && org && org.buyer)
            || (userOrg && userOrg.maker && org && org.reseller)
        ) {
            isSeller = true;
        }

        // console.log("notificationLoad", isBuyer, isSeller)

        if (!isBuyer && !isSeller) {
            return;
        }
        db.collection("notification")
            .doc("main")
            .onSnapshot((doc) => {
                if (!doc.exists) {
                    console.log("no notification doc");
                    return;
                }

                const data = doc.data();
                // console.log("raw notification:", data);

                // Firestore Timestamp → JS Date
                const now = new Date();
                const start = data.displayStart ? data.displayStart.toDate() : null;
                const end = data.displayEnd ? data.displayEnd.toDate() : null;

                let isInRange = true;

                // if start is set, now must be >= start
                if (start && now < start) {
                    isInRange = false;
                }

                // if end is set, now must be <= end
                if (end && now > end) {
                    isInRange = false;
                }

                // optional: also check isActive flag from Firestore
                const isActive = data.isActive !== false; // default true if not set

                const targetUser =
                    data.userType === 'all' ||
                    (data.userType === 'buyer' && isBuyer) ||
                    (data.userType === 'seller' && isSeller);

                if (isInRange && isActive && targetUser) {
                    // console.log("✅ show notification:", data);
                    this.setState({ notification: data, showNotification: true });
                } else {
                    // console.log("⏹ hide notification (out of range or inactive)");
                    this.setState({ showNotification: false });
                }
            });
    }

    pinOrg = async (orgId, pinned) => {
        let pinOrgRef = this.props.db.collection('org_select').doc(this.props.user.id).collection('org').doc(orgId);
        let pinOrgSnapshot = await pinOrgRef.get();

        // let selectCountOrgs = this.state.selectCountOrgs;
        // let find = selectCountOrgs.find(o => o.id === orgId);
        // if (find) {
        //     find.pinned = true;
        // }

        if (!pinOrgSnapshot.exists) {
            await pinOrgRef.set({ selectCount: firebase.firestore.FieldValue.increment(1), pinned: true }, { merge: true });
        } else {
            await pinOrgRef.set({ selectCount: firebase.firestore.FieldValue.increment(1), pinned: !pinned }, { merge: true });
        }

        await this.getTopOrgs();
    }

    render() {
        const organizationUnread = this.sumObjectsByKey(
            this.props.unreadOrderWithOrg,
            this.props.unreadBillWithOrg,
            this.props.unreadDeliveryNotesWithOrg,
            this.props.unreadEstimates2WithOrg,
            this.props.unreadEstimatesWithOrg,
            this.props.unreadReportWithOrg,
            this.props.unreadOCHWithOrg,
            // nextProps.sdsWaitingCountWithOrg
        );
        const unread = (
            (this.props.unreadOrder || 0) +
            (this.props.unreadBill || 0) +
            (this.props.unreadDeliveryNotes || 0) +
            (this.props.unreadEstimates2 || 0) +
            (this.props.unreadEstimates || 0) +
            (this.props.unreadReport || 0) +
            (this.props.unreadOCH || 0)
            // nextProps.sdsWaitingCount
        );
        const unreadNotShipped = this.props.notShippedOrder;

        const renderItem = (title, count) => ({
            value: title,
            label: (
                <Flex align="center" justify="space-between">
                    {title}
                    <span>
                        <UserOutlined /> {count}
                    </span>
                </Flex>
            ),
        });

        // console.log('this.state.organization', this.state.organization, this.state.sellerOrganizations, this.state.buyerOrganizations)

        let orgList = [];
        let orgList2 = [];
        let orgListUser = [];

        // console.log('this.state.organization', this.state.organization)

        let sellerOrganizations = this.state.sellerOrganizations;
        // if (this.state.searchOrg) {
        //     sellerOrganizations = this.state.filteredOrg;
        // }
        //
        let buyerOrganizations = this.state.buyerOrganizations;
        // if (this.state.searchOrg1) {
        //     buyerOrganizations = this.state.filteredOrg1;
        // }
        //
        let buyersOrganizations = this.state.organization && this.state.organization.buyers;
        // if (this.state.searchOrgBuyer || this.state.searchOrgBuyerSeller) {
        //     buyersOrganizations = this.state.filteredOrgBuyer;
        // }
        //
        let sellersOrganizations = this.state.organization && this.state.organization.sellers;
        // if (this.state.searchOrgSeller || this.state.searchOrgBuyerSeller) {
        //     sellersOrganizations = this.state.filteredOrgSeller;
        // }
        //
        let resellerOrganizations = this.state.organization && this.state.organization.resellers;
        // if (this.state.searchOrgSeller || this.state.searchOrgBuyerSeller) {
        //     resellerOrganizations = this.state.filteredOrgReseller;
        // }
        //
        let customersOrganizations = this.state.organization && this.state.organization.customers;
        // if (this.state.searchOrgCustomer) {
        //     customersOrganizations = this.state.filteredOrgCustomer;
        // }

        let possibleSelectOrg = this.props.location.pathname !== '/';
        // console.log('this.props.org.display_name', this.props, this.state.organization);
        // console.log('buyersOrganizations', buyersOrganizations);
        // console.log('sellersOrganizations', sellersOrganizations);
        let addonBeforeName = ''
        if (this.state.organization && this.state.organization.administrator) {
            customersOrganizations.map((customers, i) => {
                orgList.push({
                    key: customers.organization ? `customer_${customers.organization}` : `customer_${i}`,
                    id: customers.organization,
                    value: `${customers.name}`,
                    label: <span style={{ display: 'flex', gap: 5 }}>
                        <Tooltip title={'未読'}><Badge color={'#52c41a'} title={''} count={organizationUnread[customers.organization] || 0} showZero={false} /></Tooltip>
                        {customers.name}
                        <Tooltip title={'未出荷'}><Badge color={'#f5222d'} title={''} count={this.props.notShippedOrderWithOrg[customers.organization] || 0} showZero={false} /></Tooltip>
                        <Tooltip title={'正常更新中'}><Badge color={'#4185F4'} title={''} overflowCount={999} count={this.props.sdsNormalCountWithOrg[customers.organization] || 0} showZero={false} /></Tooltip>
                        <Tooltip title={'チェック更新期限日まで1週間以内'}><Badge color={'#FEBE48'} title={''} overflowCount={999} count={this.props.sdsWarningCountWithOrg[customers.organization] || 0} showZero={false} /></Tooltip>
                        <Tooltip title={'チェック更新日期限切れ'}><Badge color={'#8000FF'} title={''} overflowCount={999} count={this.props.sdsAlertCountWithOrg[customers.organization] || 0} showZero={false} /></Tooltip>
                        <Tooltip title={'SDS管理依頼中'}><Badge color={'#58C7C4'} title={''} overflowCount={999} count={this.props.sdsWaitingCountWithOrg[customers.organization] || 0} showZero={false} /></Tooltip>
                        <Tooltip title={'キャンセル承認待'}><Badge style={{ borderRadius: 0 }} color={'#ff63e0'} title={''} overflowCount={999} count={this.props.cancelOrderWithOrg[customers.organization] || 0} showZero={false} /></Tooltip>
                        <Tooltip title={'返品承認待'}><Badge style={{ borderRadius: 0 }} color={'#00C2FF'} title={''} overflowCount={999} count={this.props.returnOrderWithOrg[customers.organization] || 0} showZero={false} /></Tooltip>
                    </span>,
                    name: customers.name,
                    organizationUnread: organizationUnread[customers.organization] || 0,
                    notShippedOrder: this.props.sdsNormalCountWithOrg[customers.organization] || 0,
                    sdsNormal: this.props.sdsNormalCountWithOrg[customers.organization] || 0,
                    sdsWarning: this.props.sdsWarningCountWithOrg[customers.organization] || 0,
                    sdsAlert: this.props.sdsAlertCountWithOrg[customers.organization] || 0,
                    sdsWait: this.props.sdsWaitingCountWithOrg[customers.organization] || 0
                });
            });
        }

        if (this.state.organization && this.state.organization.reseller) {
            if ((this.props.org && this.props.org.display_name && !this.props.location.pathname.startsWith('/measurement'))) {
                addonBeforeName = this.props.org.maker ? '[仕入モード]　' : (this.props.org.buyer ? '[販売モード]' : '');
            } else if (this.props.location.pathname.startsWith('/measurement')) {
                addonBeforeName = this.props.location.pathname.startsWith('/measurement') ? '[測定データモード]' : '手順②相手先事業所を選択してください。'
            }
            // orgList.push({
            //     label: <input autoFocus type={'text'} className={'form-control'} placeholder={'名前検索'}
            //                   value={this.state.searchOrgBuyerSeller} onChange={this.handleChangeBuyerSeller}
            //                   onKeyDown={(event) => this.handleKeyDown(event, buyersOrganizations || [], sellersOrganizations || [])}/>
            // })
            if (buyersOrganizations) {
                buyersOrganizations.map((buyers, i) => {
                    orgList.push({
                        key: buyers.organization ? `buyer_${buyers.organization}` : `buyer_${i}`,
                        id: buyers.organization,
                        value: `[売先] ${buyers.name}`,
                        label:
                            <span style={{ display: 'flex', gap: 5, fontSize: '14px' }}>
                                {organizationUnread[buyers.organization] > 0 &&
                                    <Tooltip title={'未読'}><Badge color={'#52c41a'} overflowCount={999} title={''}
                                        count={organizationUnread[buyers.organization] || 0} showZero={false} /></Tooltip>}
                                [売先] {buyers.name}
                                {this.props.notShippedOrderWithOrg[buyers.organization] > 0 &&
                                    <Tooltip title={'未出荷'}><Badge color={'#f5222d'} overflowCount={999} title={''}
                                        count={this.props.notShippedOrderWithOrg[buyers.organization] || 0}
                                        showZero={false} /></Tooltip>}
                                {this.props.sdsNormalCountWithOrg[buyers.organization] > 0 &&
                                    <Tooltip title={'正常更新中'}><Badge color={'#4185F4'} overflowCount={999} title={''}
                                        count={this.props.sdsNormalCountWithOrg[buyers.organization] || 0}
                                        showZero={false} /></Tooltip>}
                                {this.props.sdsWarningCountWithOrg[buyers.organization] > 0 &&
                                    <Tooltip title={'チェック更新期限日まで1週間以内'}><Badge color={'#FEBE48'} overflowCount={999} title={''}
                                        count={this.props.sdsWarningCountWithOrg[buyers.organization] || 0}
                                        showZero={false} /></Tooltip>}
                                {this.props.sdsAlertCountWithOrg[buyers.organization] > 0 &&
                                    <Tooltip title={'チェック更新日期限切れ'}><Badge color={'#8000FF'} overflowCount={999} title={''}
                                        count={this.props.sdsAlertCountWithOrg[buyers.organization] || 0}
                                        showZero={false} /></Tooltip>}
                                {this.props.sdsWaitingCountWithOrg[buyers.organization] > 0 &&
                                    <Tooltip title={'SDS管理依頼中'}><Badge color={'#58C7C4'} overflowCount={999} title={''}
                                        count={this.props.sdsWaitingCountWithOrg[buyers.organization] || 0}
                                        showZero={false} /></Tooltip>}
                                {this.props.cancelOrderWithOrg[buyers.organization] > 0 && <Tooltip title={'キャンセル承認待'}><Badge style={{ borderRadius: 0 }} color={'#ff63e0'} title={''} overflowCount={999} count={this.props.cancelOrderWithOrg[buyers.organization] || 0} showZero={false} /></Tooltip>}
                                {this.props.returnOrderWithOrg[buyers.organization] > 0 && <Tooltip title={'返品承認待'}><Badge style={{ borderRadius: 0 }} color={'#00C2FF'} title={''} overflowCount={999} count={this.props.returnOrderWithOrg[buyers.organization] || 0} showZero={false} /></Tooltip>}
                            </span>,
                        name: buyers.name,
                        organizationUnread: organizationUnread[buyers.organization] || 0,
                        notShippedOrder: this.props.sdsNormalCountWithOrg[buyers.organization] || 0,
                        sdsNormal: this.props.sdsNormalCountWithOrg[buyers.organization] || 0,
                        sdsWarning: this.props.sdsWarningCountWithOrg[buyers.organization] || 0,
                        sdsAlert: this.props.sdsAlertCountWithOrg[buyers.organization] || 0,
                        sdsWait: this.props.sdsWaitingCountWithOrg[buyers.organization] || 0
                    });
                });
            }

            if (sellersOrganizations) {
                sellersOrganizations.map((seller, i) => {
                    orgList.push({
                        key: seller.organization ? `seller_${seller.organization}` : `seller_${i}`,
                        id: seller.organization,
                        value: `[仕入先] ${seller.name}`,
                        label: <span style={{
                            display: 'flex', gap: 5//,backgroundColor: this.props.org && this.props.org.display_name === seller.name ? '#007bff' : ''
                        }}>
                            {organizationUnread[seller.organization] > 0 &&
                                <Tooltip title={'未読'}><Badge color={'#52c41a'} overflowCount={999} title={''}
                                    count={organizationUnread[seller.organization] || 0} showZero={false} /></Tooltip>}
                            [仕入先] {seller.name}
                            {this.props.notShippedOrderWithOrg[seller.organization] > 0 &&
                                <Tooltip title={'未出荷'}><Badge color={'#f5222d'} overflowCount={999} title={''}
                                    count={this.props.notShippedOrderWithOrg[seller.organization] || 0}
                                    showZero={false} /></Tooltip>}
                            {this.props.sdsNormalCountWithOrg[seller.organization] > 0 &&
                                <Tooltip title={'正常更新中'}><Badge color={'#4185F4'} overflowCount={999} title={''}
                                    count={this.props.sdsNormalCountWithOrg[seller.organization] || 0}
                                    showZero={false} /></Tooltip>}
                            {this.props.sdsWarningCountWithOrg[seller.organization] > 0 &&
                                <Tooltip title={'チェック更新期限日まで1週間以内'}><Badge color={'#FEBE48'} overflowCount={999} title={''}
                                    count={this.props.sdsWarningCountWithOrg[seller.organization] || 0}
                                    showZero={false} /></Tooltip>}
                            {this.props.sdsAlertCountWithOrg[seller.organization] > 0 &&
                                <Tooltip title={'チェック更新日期限切れ'}><Badge color={'#8000FF'} overflowCount={999} title={''}
                                    count={this.props.sdsAlertCountWithOrg[seller.organization] || 0}
                                    showZero={false} /></Tooltip>}
                            {this.props.sdsWaitingCountWithOrg[seller.organization] > 0 &&
                                <Tooltip title={'SDS管理依頼中'}><Badge color={'#58C7C4'} overflowCount={999} title={''}
                                    count={this.props.sdsWaitingCountWithOrg[seller.organization] || 0}
                                    showZero={false} /></Tooltip>}
                            {this.props.cancelOrderWithOrg[seller.organization] > 0 && <Tooltip title={'キャンセル承認待'}><Badge style={{ borderRadius: 0 }} color={'#ff63e0'} title={''} overflowCount={999} count={this.props.cancelOrderWithOrg[seller.organization] || 0} showZero={false} /></Tooltip>}
                            {this.props.returnOrderWithOrg[seller.organization] > 0 && <Tooltip title={'返品承認待'}><Badge style={{ borderRadius: 0 }} color={'#00C2FF'} title={''} overflowCount={999} count={this.props.returnOrderWithOrg[seller.organization] || 0} showZero={false} /></Tooltip>}
                        </span>,
                        name: seller.name,
                        organizationUnread: organizationUnread[seller.organization] || 0,
                        notShippedOrder: this.props.sdsNormalCountWithOrg[seller.organization] || 0,
                        sdsNormal: this.props.sdsNormalCountWithOrg[seller.organization] || 0,
                        sdsWarning: this.props.sdsWarningCountWithOrg[seller.organization] || 0,
                        sdsAlert: this.props.sdsAlertCountWithOrg[seller.organization] || 0,
                        sdsWait: this.props.sdsWaitingCountWithOrg[seller.organization] || 0
                    });
                });
            }

        }

        if (this.state.organization && this.state.organization.buyer) {
            // console.log('buyer org list', resellerOrganizations);

            if (resellerOrganizations) {
                resellerOrganizations.map((seller, i) => {
                    orgList.push({
                        key: seller.organization ? `reseller_${seller.organization}` : `reseller_${i}`,
                        id: seller.organization,
                        value: `[仕入先] ${seller.name}`,
                        label: <span style={{
                            display: 'flex', gap: 5//,backgroundColor: this.props.org && this.props.org.display_name === seller.name ? '#007bff' : ''
                        }}>
                            {organizationUnread[seller.organization] > 0 &&
                                <Tooltip title={'未読'}><Badge color={'#52c41a'} overflowCount={999} title={''}
                                    count={organizationUnread[seller.organization] || 0} showZero={false} /></Tooltip>}
                            [仕入先] {seller.name}
                            {this.props.notShippedOrderWithOrg[seller.organization] > 0 &&
                                <Tooltip title={'未出荷'}><Badge color={'#f5222d'} overflowCount={999} title={''}
                                    count={this.props.notShippedOrderWithOrg[seller.organization] || 0}
                                    showZero={false} /></Tooltip>}
                            {this.props.sdsNormalCountWithOrg[seller.organization] > 0 &&
                                <Tooltip title={'正常更新中'}><Badge color={'#4185F4'} overflowCount={999} title={''}
                                    count={this.props.sdsNormalCountWithOrg[seller.organization] || 0}
                                    showZero={false} /></Tooltip>}
                            {this.props.sdsWarningCountWithOrg[seller.organization] > 0 &&
                                <Tooltip title={'チェック更新期限日まで1週間以内'}><Badge color={'#FEBE48'} overflowCount={999} title={''}
                                    count={this.props.sdsWarningCountWithOrg[seller.organization] || 0}
                                    showZero={false} /></Tooltip>}
                            {this.props.sdsAlertCountWithOrg[seller.organization] > 0 &&
                                <Tooltip title={'チェック更新日期限切れ'}><Badge color={'#8000FF'} overflowCount={999} title={''}
                                    count={this.props.sdsAlertCountWithOrg[seller.organization] || 0}
                                    showZero={false} /></Tooltip>}
                            {this.props.sdsWaitingCountWithOrg[seller.organization] > 0 &&
                                <Tooltip title={'SDS管理依頼中'}><Badge color={'#58C7C4'} overflowCount={999} title={''}
                                    count={this.props.sdsWaitingCountWithOrg[seller.organization] || 0}
                                    showZero={false} /></Tooltip>}
                            {this.props.cancelOrderWithOrg[seller.organization] > 0 && <Tooltip title={'キャンセル承認待'}><Badge style={{ borderRadius: 0 }} color={'#ff63e0'} title={''} overflowCount={999} count={this.props.cancelOrderWithOrg[seller.organization] || 0} showZero={false} /></Tooltip>}
                            {this.props.returnOrderWithOrg[seller.organization] > 0 && <Tooltip title={'返品承認待'}><Badge style={{ borderRadius: 0 }} color={'#00C2FF'} title={''} overflowCount={999} count={this.props.returnOrderWithOrg[seller.organization] || 0} showZero={false} /></Tooltip>}
                        </span>,
                        name: seller.name,
                        organizationUnread: organizationUnread[seller.organization] || 0,
                        notShippedOrder: this.props.sdsNormalCountWithOrg[seller.organization] || 0,
                        sdsNormal: this.props.sdsNormalCountWithOrg[seller.organization] || 0,
                        sdsWarning: this.props.sdsWarningCountWithOrg[seller.organization] || 0,
                        sdsAlert: this.props.sdsAlertCountWithOrg[seller.organization] || 0,
                        sdsWait: this.props.sdsWaitingCountWithOrg[seller.organization] || 0
                    })
                })
            }
        }

        if (this.state.organization && this.state.organization.maker) {
            if ((this.props.org && this.props.org.display_name && !this.props.location.pathname.startsWith('/measurement'))) {
                addonBeforeName = '';
            } else {
                addonBeforeName = this.props.location.pathname.startsWith('/measurement') ? '[測定データモード]' : ''//'手順②相手先事業所を選択してください。'
            }
            if (buyersOrganizations) {
                buyersOrganizations.map((buyers, i) => {
                    orgList.push({
                        key: buyers.organization ? `maker_buyer_${buyers.organization}` : `maker_buyer_${i}`,
                        id: buyers.organization,
                        value: `[売先] ${buyers.name}`,
                        label: <span style={{ display: 'flex', gap: 5 }}>
                            {organizationUnread[buyers.organization] > 0 && <Tooltip title={'未読'}><Badge color={'#52c41a'} title={''} overflowCount={999} count={organizationUnread[buyers.organization] || 0} showZero={false} /></Tooltip>}
                            [売先] {buyers.name}
                            {this.props.notShippedOrderWithOrg[buyers.organization] > 0 && <Tooltip title={'未出荷'}><Badge color={'#f5222d'} title={''} overflowCount={999} count={this.props.notShippedOrderWithOrg[buyers.organization] || 0} showZero={false} /></Tooltip>}
                            {this.props.sdsNormalCountWithOrg[buyers.organization] > 0 && <Tooltip title={'正常更新中'}><Badge color={'#4185F4'} title={''} overflowCount={999} count={this.props.sdsNormalCountWithOrg[buyers.organization] || 0} showZero={false} /></Tooltip>}
                            {this.props.sdsWarningCountWithOrg[buyers.organization] > 0 && <Tooltip title={'チェック更新期限日まで1週間以内'}><Badge color={'#FEBE48'} title={''} overflowCount={999} count={this.props.sdsWarningCountWithOrg[buyers.organization] || 0} showZero={false} /></Tooltip>}
                            {this.props.sdsAlertCountWithOrg[buyers.organization] > 0 && <Tooltip title={'チェック更新日期限切れ'}><Badge color={'#8000FF'} title={''} overflowCount={999} count={this.props.sdsAlertCountWithOrg[buyers.organization] || 0} showZero={false} /></Tooltip>}
                            {this.props.sdsWaitingCountWithOrg[buyers.organization] > 0 && <Tooltip title={'SDS管理依頼中'}><Badge color={'#58C7C4'} title={''} overflowCount={999} count={this.props.sdsWaitingCountWithOrg[buyers.organization] || 0} showZero={false} /></Tooltip>}
                            {this.props.cancelOrderWithOrg[buyers.organization] > 0 && <Tooltip title={'キャンセル承認待'}><Badge style={{ borderRadius: 0 }} color={'#ff63e0'} title={''} overflowCount={999} count={this.props.cancelOrderWithOrg[buyers.organization] || 0} showZero={false} /></Tooltip>}
                            {this.props.returnOrderWithOrg[buyers.organization] > 0 && <Tooltip title={'返品承認待'}><Badge style={{ borderRadius: 0 }} color={'#00C2FF'} title={''} overflowCount={999} count={this.props.returnOrderWithOrg[buyers.organization] || 0} showZero={false} /></Tooltip>}
                        </span>,
                        name: buyers.name,
                        organizationUnread: organizationUnread[buyers.organization] || 0,
                        notShippedOrder: this.props.sdsNormalCountWithOrg[buyers.organization] || 0,
                        sdsNormal: this.props.sdsNormalCountWithOrg[buyers.organization] || 0,
                        sdsWarning: this.props.sdsWarningCountWithOrg[buyers.organization] || 0,
                        sdsAlert: this.props.sdsAlertCountWithOrg[buyers.organization] || 0,
                        sdsWait: this.props.sdsWaitingCountWithOrg[buyers.organization] || 0
                    });
                });
            }
        }
        if (this.props.user.admin) {
            if (!this.props.location.pathname.startsWith('/measurement') && this.props.orgSeller && this.props.orgSeller.display_name) {
                addonBeforeName = ''//this.props.orgSeller.display_name;
            }
            else {
                addonBeforeName = this.props.location.pathname.startsWith('/measurement') ? '[測定データモード]' : '' //販売モード側事業所選択
            }
            if (sellerOrganizations) {
                sellerOrganizations.map((seller, i) => {
                    orgList.push({
                        key: seller.id ? `admin_seller_${seller.id}` : `admin_seller_${i}`,
                        id: seller.id,
                        value: `[販売側] ${seller.company_name} ${seller.name}`,
                        label: <span style={{ display: 'flex', gap: 5 }}>
                            [販売側] {seller.company_name} {seller.name}
                            {this.props.sdsNormalCountWithOrg[seller.id] > 0 && <Tooltip title={'正常更新中'}><Badge color={'#4185F4'} title={''} overflowCount={999} count={this.props.sdsNormalCountWithOrg[seller.id] || 0} showZero={false} /></Tooltip>}
                            {this.props.sdsWarningCountWithOrg[seller.id] > 0 && <Tooltip title={'チェック更新期限日まで1週間以内'}><Badge color={'#FEBE48'} title={''} overflowCount={999} count={this.props.sdsWarningCountWithOrg[seller.id] || 0} showZero={false} /></Tooltip>}
                            {this.props.sdsAlertCountWithOrg[seller.id] > 0 && <Tooltip title={'チェック更新日期限切れ'}><Badge color={'#8000FF'} title={''} overflowCount={999} count={this.props.sdsAlertCountWithOrg[seller.id] || 0} showZero={false} /></Tooltip>}
                            {this.props.sdsWaitingCountWithOrg[seller.id] > 0 && <Tooltip title={'SDS管理依頼中'}><Badge color={'#58C7C4'} title={''} overflowCount={999} count={this.props.sdsWaitingCountWithOrg[seller.id] || 0} showZero={false} /></Tooltip>}
                            {this.props.cancelOrderWithOrg[seller.id] > 0 && <Tooltip title={'キャンセル承認待'}><Badge style={{ borderRadius: 0 }} color={'#ff63e0'} title={''} overflowCount={999} count={this.props.cancelOrderWithOrg[seller.id] || 0} showZero={false} /></Tooltip>}
                            {this.props.returnOrderWithOrg[seller.id] > 0 && <Tooltip title={'返品承認待'}><Badge style={{ borderRadius: 0 }} color={'#00C2FF'} title={''} overflowCount={999} count={this.props.returnOrderWithOrg[seller.id] || 0} showZero={false} /></Tooltip>}
                        </span>,
                        name: seller.name,
                        name2: `${seller.company_name} ${seller.name}`,
                        organizationUnread: organizationUnread[seller.organization] || 0,
                        notShippedOrder: this.props.sdsNormalCountWithOrg[seller.organization] || 0,
                        sdsNormal: this.props.sdsNormalCountWithOrg[seller.organization] || 0,
                        sdsWarning: this.props.sdsWarningCountWithOrg[seller.organization] || 0,
                        sdsAlert: this.props.sdsAlertCountWithOrg[seller.organization] || 0,
                        sdsWait: this.props.sdsWaitingCountWithOrg[seller.organization] || 0,
                        buyers: seller.buyers
                    });
                });
            }
            if (buyerOrganizations) {
                buyerOrganizations.map((buyers, i) => {
                    let sdsNormal = 0;
                    let sdsWarning = 0;
                    let sdsAlert = 0;
                    let sdsWait = 0;

                    if (this.props.user.admin && this.props.orgSeller) {
                        const pairKey = `${this.props.orgSeller.id}_${buyers.organization}`;
                        sdsNormal = (this.props.sdsNormalCountPairs && this.props.sdsNormalCountPairs[pairKey]) || 0;
                        sdsWarning = (this.props.sdsWarningCountPairs && this.props.sdsWarningCountPairs[pairKey]) || 0;
                        sdsAlert = (this.props.sdsAlertCountPairs && this.props.sdsAlertCountPairs[pairKey]) || 0;
                        sdsWait = (this.props.sdsWaitingCountPairs && this.props.sdsWaitingCountPairs[pairKey]) || 0;
                    } else {
                        sdsNormal = (this.props.sdsNormalCountWithOrg && this.props.sdsNormalCountWithOrg[buyers.organization]) || 0;
                        sdsWarning = (this.props.sdsWarningCountWithOrg && this.props.sdsWarningCountWithOrg[buyers.organization]) || 0;
                        sdsAlert = (this.props.sdsAlertCountWithOrg && this.props.sdsAlertCountWithOrg[buyers.organization]) || 0;
                        sdsWait = (this.props.sdsWaitingCountWithOrg && this.props.sdsWaitingCountWithOrg[buyers.organization]) || 0;
                    }

                    orgList2.push({
                        key: buyers.organization ? `admin_buyer_${buyers.organization}` : `admin_buyer_${i}`,
                        id: buyers.organization,
                        value: `[売先] ${buyers.name}`,
                        label: <span style={{ display: 'flex', gap: 5 }}>
                            [売先] {buyers.name}
                            {sdsNormal > 0 && <Tooltip title={'正常更新中'}><Badge color={'#4185F4'} title={''} overflowCount={999} count={sdsNormal} showZero={false} /></Tooltip>}
                            {sdsWarning > 0 && <Tooltip title={'チェック更新期限日まで1週間以内'}><Badge color={'#FEBE48'} title={''} overflowCount={999} count={sdsWarning} showZero={false} /></Tooltip>}
                            {sdsAlert > 0 && <Tooltip title={'チェック更新日期限切れ'}><Badge color={'#8000FF'} title={''} overflowCount={999} count={sdsAlert} showZero={false} /></Tooltip>}
                            {sdsWait > 0 && <Tooltip title={'SDS管理依頼中'}><Badge color={'#58C7C4'} title={''} overflowCount={999} count={sdsWait} showZero={false} /></Tooltip>}
                            {this.props.cancelOrderWithOrg[buyers.organization] > 0 && <Tooltip title={'キャンセル承認待'}><Badge style={{ borderRadius: 0 }} color={'#ff63e0'} title={''} overflowCount={999} count={this.props.cancelOrderWithOrg[buyers.organization] || 0} showZero={false} /></Tooltip>}
                            {this.props.returnOrderWithOrg[buyers.organization] > 0 && <Tooltip title={'返品承認待'}><Badge style={{ borderRadius: 0 }} color={'#00C2FF'} title={''} overflowCount={999} count={this.props.returnOrderWithOrg[buyers.organization] || 0} showZero={false} /></Tooltip>}
                        </span>,
                        name: buyers.name,
                        organizationUnread: organizationUnread[buyers.organization] || 0,
                        notShippedOrder: sdsNormal,
                        sdsNormal: sdsNormal,
                        sdsWarning: sdsWarning,
                        sdsAlert: sdsAlert,
                        sdsWait: sdsWait
                    });
                });
            }
        }

        if (this.props.user && this.props.user.organizations) {
            // console.log('user org',this.props.userOrg)
            this.props.user.organizations.map((buyer, i) => {
                orgListUser.push({
                    key: buyer.organization ? `user_org_${buyer.organization}` : `user_org_${i}`,
                    id: buyer.organization,
                    value: `${buyer.name}`,
                    label: <span style={{ display: 'flex', gap: 5 }}>
                        {buyer.name}
                    </span>
                });
            });

            // if (orgListUser.length === 1 && !this.props.userOrg) {
            //     console.log('this.props.userOrg', this.props.userOrg)
            //     this.organizationCheck(orgListUser[0].id, false)
            // }
        }

        let kaigawa = false;
        let urigawa = false;
        let cancelTooltip = "キャンセル待ち";
        let returnTooltip = "返品待ち";
        if ((this.props.userOrg && this.props.userOrg.buyer && this.props.org && this.props.org.reseller)
            || (this.props.userOrg && this.props.userOrg.reseller && this.props.org && this.props.org.maker)
        ) {
            kaigawa = true;
            cancelTooltip = "キャンセル依頼中";
            returnTooltip = "返品依頼中";
        }
        if ((this.props.userOrg && this.props.userOrg.reseller && this.props.org && this.props.org.buyer)
            || (this.props.userOrg && this.props.userOrg.maker && this.props.org && this.props.org.reseller)
        ) {
            urigawa = true;
            cancelTooltip = "キャンセル承認待";
            returnTooltip = "返品承認待"
        }

        let selectCountOrgs = this.state.selectCountOrgs;

        const merged = orgList.map(item => {
            const countObj = selectCountOrgs.find(c => c.id === item.id);
            // console.log('countObj',countObj)
            return {
                ...item,
                selectCount: countObj ? countObj.selectCount : 0, // Default to 0 if not found
                pinned: countObj ? countObj.pinned : false
            };
        });

        // merged.sort((a, b) => b.selectCount - a.selectCount);
        merged.sort((a, b) => {
            if (a.pinned === b.pinned) {
                return b.selectCount - a.selectCount;
            }
            return b.pinned - a.pinned; // true (1) comes before false (0)
        });
        orgList = merged;

        const merged2 = orgList2.map(item => {
            const countObj = selectCountOrgs.find(c => c.id === item.id);
            return {
                ...item,
                selectCount: countObj ? countObj.selectCount : 0
            };
        });

        merged2.sort((a, b) => b.selectCount - a.selectCount);
        orgList2 = merged2;

        // console.log('merged', merged, merged2);

        return (<>
            {/*<div style={{height: 30, textAlign: 'center'}}>TESTペイント株式会社 本社</div>*/}
            <Header
                style={{
                    padding: 0,
                    background: '#FFFFFF',
                    position: 'sticky',
                    top: 0,
                    display: 'flex',
                    justifyContent: 'space-between',
                    zIndex: 3
                }}
            >
                <div style={{ flex: 1, display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'space-between', gap: 10 }}>
                    <div style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'row', alignItems: 'center', flex: 1 }}>
                        <Button
                            type="text"
                            icon={this.props.collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                            onClick={() => this.props.setCollapsed(!this.props.collapsed)}
                            style={{
                                fontSize: '16px',
                                width: 64,
                                height: 64
                            }}
                        />
                        {/*<div className="d-none d-md-inline">
                        {(this.props.org && this.props.org.display_name && !this.props.location.pathname.startsWith('/measurement')) ?
                            <span style={{fontSize:'12pt'}}>
                                {this.props.org.maker ? '[仕入モード]　' : ''}
                                {this.props.org.buyer ? '[販売モード]　' : ''}
                            </span>
                            :
                            this.props.location.pathname.startsWith('/measurement') ? <span style={{fontSize:'12pt',marginRight:10}}>[測定データモード]</span> : <></>
                        }
                        </div>*/}
                        {!this.props.user.admin && <div>
                            <Tooltip title={possibleSelectOrg ? "「詳細画面」では所属事業所、相手先事業所を切り替えることはできません。Home画面に戻って選択し直してください。" : null} placement="top">
                                <Select
                                    showSearch={true}
                                    style={{ flex: 1 }}
                                    popupClassName="header-org-select-dropdown"
                                    dropdownClassName="header-org-select-dropdown"
                                    listHeight={typeof window !== 'undefined' && window.innerHeight ? Math.floor(window.innerHeight * 0.8) : 500}
                                    placeholder="手順①自社所属事業所を選択してください。"
                                    optionFilterProp="value"
                                    size={"large"}
                                    options={orgListUser}
                                    notFoundContent={'データなし'}
                                    disabled={possibleSelectOrg}
                                    //defaultValue={this.props.org && this.props.org.display_name}
                                    value={this.props.userOrg && this.props.userOrg.display_name}
                                    onSearch={(text) => this.setState({ searchUserOrg: text })}
                                    onSelect={(value, option) => this.selectUserOrg(value, option)}
                                    // showArrow={(this.props.userOrg && this.props.userOrg.buyer) ? false : true}
                                    // open={(this.props.userOrg && this.props.userOrg.buyer) ? false : undefined}
                                    optionRender={(option) => (
                                        <div className={`${this.props.userOrg && this.props.userOrg.id === option.data.id ? 'ant-select-item-option-selected' : ''}`} style={{ display: 'flex', flexDirection: 'row', padding: 2, alignItems: 'center', justifyContent: 'space-between' }}>{option.label}</div>)}>
                                </Select>
                            </Tooltip>
                        </div>}

                        <div style={{ fontSize: '14px', marginRight: 10, marginLeft: 10 }}>{addonBeforeName}</div>
                        {
                            !this.props.user.admin ? <Tooltip title={possibleSelectOrg ? "「詳細画面」では所属事業所、相手先事業所を切り替えることはできません。Home画面に戻って選択し直してください。" : null} placement="top"><Select
                                showSearch={true}
                                style={{ flex: 1 }}
                                popupClassName="header-org-select-dropdown"
                                dropdownClassName="header-org-select-dropdown"
                                // popupMatchSelectWidth={600}
                                listHeight={typeof window !== 'undefined' && window.innerHeight ? Math.floor(window.innerHeight * 0.8) : 500}
                                placeholder="手順②相手先事業所を選択してください。"
                                optionFilterProp="value"
                                size={"large"}
                                options={orgList}
                                notFoundContent={'先に「手順①自社所属事業所を選択」してください。'}
                                disabled={possibleSelectOrg}
                                //defaultValue={this.props.org && this.props.org.display_name}
                                value={this.props.org && this.props.org.display_name}
                                onSearch={(text) => this.setState({ searchOrg: text })}
                                onSelect={(value, option) => this.selectOrg(value, option)}
                                // showArrow={(this.props.userOrg && this.props.userOrg.buyer) ? false : true}
                                // open={(this.props.userOrg && this.props.userOrg.buyer) ? false : undefined}
                                optionRender={(option) => (
                                    <div className={`${this.props.org && this.props.org.id === option.data.id ? 'ant-select-item-option-selected' : ''}`} style={{ display: 'flex', flexDirection: 'row', padding: 2, alignItems: 'center', justifyContent: 'space-between' }}>{option.label} <Button type={"text"} icon={<PushpinOutlined style={{ color: option.data.pinned ? '#1677ff' : '#999' }} rotate={option.data.pinned ? 0 : 90} />} onClick={(e) => { e.stopPropagation(); this.pinOrg(option.data.id, option.data.pinned) }} /></div>)}>
                            </Select></Tooltip> :
                                <Select
                                    showSearch={true}
                                    style={{ flex: 1 }}
                                    popupClassName="header-org-select-dropdown"
                                    dropdownClassName="header-org-select-dropdown"
                                    //popupMatchSelectWidth={400}
                                    listHeight={typeof window !== 'undefined' && window.innerHeight ? Math.floor(window.innerHeight * 0.8) : 500}
                                    placeholder={"手順①自社所属事業所を選択してください。"}
                                    optionFilterProp="value"
                                    size={"large"}
                                    options={orgList}
                                    notFoundContent={'データなし'}
                                    //defaultValue={this.props.org && this.props.org.display_name}
                                    value={this.props.orgSeller && this.props.orgSeller.display_name}
                                    onSearch={(text) => this.setState({ searchOrg: text })}
                                    onSelect={(value, option) => this.selectSellerOrganization(option, false)}
                                    // showArrow={(this.props.userOrg && this.props.userOrg.buyer) ? false : true}
                                    // open={(this.props.userOrg && this.props.userOrg.buyer) ? false : undefined}
                                    optionRender={(option) => {
                                        // console.log('option', option,this.props.orgSeller && this.props.orgSeller.display_name);
                                        return (
                                            <div className={`${this.props.orgSeller && this.props.orgSeller.id === option.data.id ? 'ant-select-item-option-selected' : ''}`}>{option.label}</div>)
                                    }}
                                >
                                </Select>
                        }
                        {
                            this.props.user.admin && !this.props.location.pathname.startsWith('/measurement') && <Select
                                showSearch={true}
                                style={{ flex: 1, marginLeft: 10 }}
                                popupClassName="header-org-select-dropdown"
                                dropdownClassName="header-org-select-dropdown"
                                //popupMatchSelectWidth={400}
                                listHeight={typeof window !== 'undefined' && window.innerHeight ? Math.floor(window.innerHeight * 0.8) : 500}
                                placeholder="手順②相手先事業所を選択してください。"
                                optionFilterProp="value"
                                size={"large"}
                                options={orgList2}
                                notFoundContent={'先に「手順①自社所属事業所を選択」してください。'}
                                //defaultValue={this.props.org && this.props.org.display_name}
                                value={this.props.org && this.props.org.display_name}
                                onSearch={(text) => this.setState({ searchOrg: text })}
                                onSelect={(value, option) => this.selectOrg(value, option)}
                                showArrow={(this.props.userOrg && this.props.userOrg.buyer) ? false : true}
                                open={(this.props.userOrg && this.props.userOrg.buyer) ? false : undefined}
                                optionRender={(option) => (
                                    <div className={`${this.props.org && this.props.org.id === option.data.id ? 'ant-select-item-option-selected' : ''}`}>{option.label}</div>)}
                            >
                            </Select>
                        }
                    </div>
                    <div>
                        {this.state.showNotification &&
                            <Button
                                type="primary"
                                size={"large"}
                                onClick={() => this.setState({ showNotif: true })}
                                style={{ minWidth: 150 }}>
                                {this.state.notification?.buttonTitle}
                            </Button>
                        }
                    </div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        flexDirection: 'row',
                        alignItems: 'center',
                        marginRight: 15,
                        gap: 5
                    }}>
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 5 }}>
                                {unread > 0 && <Tooltip title={'通知'}>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960"
                                        width="24px" fill="#5f6368">
                                        <path
                                            d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z" />
                                    </svg>
                                </Tooltip>}
                                {unread > 0 && <div style={{ display: 'flex', minWidth: 36.2 }}>
                                    <Tooltip title={'未読'}>
                                        <Badge style={{ cursor: 'pointer' }} color={'#52c41a'} overflowCount={999} title={''}
                                            count={unread}
                                            showZero={false} />
                                    </Tooltip>
                                </div>}

                                <Tooltip title={'SDS管理'}>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960"
                                        width="24px" fill="#5f6368">
                                        <path
                                            d="m40-120 440-760 440 760H40Zm138-80h604L480-720 178-200Zm302-40q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm-40-120h80v-200h-80v200Zm40-100Z" />
                                    </svg>
                                </Tooltip>
                                {(() => {
                                    const { normal, warning, alert, wait } = this.getSDSCounts();
                                    return <>
                                        {normal > 0 && <Tooltip title={'正常更新中'}><Badge style={{ cursor: 'pointer' }} color={'#4185F4'} title={''} overflowCount={999} count={normal} showZero={false} /></Tooltip>}
                                        {warning > 0 && <Tooltip title={'チェック更新期限日まで1週間以内'}><Badge style={{ cursor: 'pointer' }} color={'#FEBE48'} title={''} overflowCount={999} count={warning} showZero={false} /></Tooltip>}
                                        {alert > 0 && <Tooltip title={'チェック更新日期限切れ'}><Badge style={{ cursor: 'pointer' }} color={'#8000FF'} title={''} overflowCount={999} count={alert} showZero={false} /></Tooltip>}
                                        {wait > 0 && <Tooltip title={'SDS管理依頼中'}><Badge style={{ cursor: 'pointer' }} color={'#58C7C4'} title={''} overflowCount={999} count={wait} showZero={false} /></Tooltip>}
                                    </>;
                                })()}
                            </div>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                gap: 5,
                                marginRight: 40
                            }}>
                                {unreadNotShipped > 0 && <Tooltip title={'出荷状況'}>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960"
                                        width="24px" fill="#5f6368">
                                        <path
                                            d="M240-160q-50 0-85-35t-35-85H40v-440q0-33 23.5-56.5T120-800h560v160h120l120 160v200h-80q0 50-35 85t-85 35q-50 0-85-35t-35-85H360q0 50-35 85t-85 35Zm0-80q17 0 28.5-11.5T280-280q0-17-11.5-28.5T240-320q-17 0-28.5 11.5T200-280q0 17 11.5 28.5T240-240ZM120-360h32q17-18 39-29t49-11q27 0 49 11t39 29h272v-360H120v360Zm600 120q17 0 28.5-11.5T760-280q0-17-11.5-28.5T720-320q-17 0-28.5 11.5T680-280q0 17 11.5 28.5T720-240Zm-40-200h170l-90-120h-80v120ZM360-540Z" />
                                    </svg>
                                </Tooltip>}
                                {unreadNotShipped > 0 && <div style={{ display: 'flex', minWidth: 36.2 }}>
                                    <Tooltip title={'未出荷'}>
                                        <Badge style={{ cursor: 'pointer' }} color={'#f5222d'} overflowCount={999} title={''}
                                            count={unreadNotShipped}
                                            showZero={false} />
                                    </Tooltip>
                                </div>}

                                <Tooltip title={'キャンセル/返品状況'}>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="m691-150 139-138-42-42-97 95-39-39-42 43 81 81ZM240-600h480v-80H240v80ZM720-40q-83 0-141.5-58.5T520-240q0-83 58.5-141.5T720-440q83 0 141.5 58.5T920-240q0 83-58.5 141.5T720-40ZM120-80v-680q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v267q-19-9-39-15t-41-9v-243H200v562h243q5 31 15.5 59T486-86l-6 6-60-60-60 60-60-60-60 60-60-60-60 60Zm120-200h203q3-21 9-41t15-39H240v80Zm0-160h284q38-37 88.5-58.5T720-520H240v80Zm-40 242v-562 562Z" /></svg>
                                </Tooltip>
                                <>
                                    {/*{this.props.orgSeller && this.props.orgSeller.id}*/}
                                    {
                                        // this.props.cancelOrderWithOrg[this.props.orgSeller && this.props.orgSeller.id] > 0 &&
                                        this.props.cancelOrder > 0 &&
                                        <Tooltip title={cancelTooltip}><Badge style={{ cursor: 'pointer', borderRadius: 0 }} color={'#ff63e0'} title={''} overflowCount={999} count={this.props.cancelOrder} showZero={false} /></Tooltip>
                                    }
                                    {
                                        // this.props.returnOrderWithOrg[this.props.orgSeller && this.props.orgSeller.id] > 0 &&
                                        this.props.returnOrder > 0 &&
                                        <Tooltip title={returnTooltip}><Badge style={{ cursor: 'pointer', borderRadius: 0 }} color={'#00C2FF'} title={''} overflowCount={999} count={this.props.returnOrder} showZero={false} /></Tooltip>
                                    }
                                </>
                            </div>
                        </div>

                        <Dropdown
                            menu={{
                                items: [
                                    {
                                        label: (<div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            padding: 20,
                                            gap: 5,
                                            alignItems: 'center'
                                        }}>
                                            <span>ユーザー情報</span>
                                            <span>{this.props.user.last_name} {this.props.user.first_name}</span>
                                            <span>{this.state.company ? this.state.company.name : ''}</span>
                                            <span>{this.state.organization ? this.state.organization.name : ''}</span>
                                        </div>),
                                        key: '0',
                                    },
                                    {
                                        label: (<span style={{ display: 'flex', gap: 5 }}><InfoCircleOutlined /> 操作方法</span>),
                                        key: '11'
                                    },
                                    {
                                        label: (<span style={{ display: 'flex', gap: 5 }}><MailOutlined /> 通知メール受信設定</span>),
                                        key: '1'
                                    },
                                    {
                                        type: 'divider',
                                    },
                                    {
                                        label: 'Logout',
                                        key: '2',
                                    },
                                ],
                                onClick: this.handleMenuClick
                            }}
                            trigger={['click']}
                            style={{ margin: 20 }}
                        >
                            <a onClick={(e) => e.preventDefault()}>

                                <Space>{this.props.user.last_name}{this.props.user.first_name}<DownOutlined /></Space>

                            </a>
                        </Dropdown>
                    </div>
                </div>

                <Modal
                    title={this.state.notification?.title}
                    centered
                    open={this.state.showNotif}
                    // onOk={() => this.setState({showNotif: false})}
                    // okText="閉じる"
                    onCancel={() => this.setState({ showNotif: false })}
                    footer={
                        <Button type="primary" onClick={() => this.setState({ showNotif: false })}>
                            閉じる
                        </Button>
                    }
                >
                    {/*<p dangerouslySetInnerHTML={{ __html: this.props.notification?.body }} />*/}
                    <div
                        style={{
                            fontSize: 14,
                            lineHeight: 1.6,
                            whiteSpace: "pre-line",   // ← これがポイント
                        }}
                    >
                        {this.state.notification?.body}
                    </div>
                </Modal>

                {/*<div style={{padding: '0 15px'}}>

                </div>*/}
            </Header>
        </>)
    }
}

export default withRouter(P4Header1);
